import styled from "styled-components";
import { IoSettingsSharp } from "react-icons/io5";
import KayitliYuklerimInput from "../../inputs/KayitliYuklerimInput";
import LoadSection from "../../mainSections/LoadSection";
import OdemeSection from "../../mainSections/OdemeSection";
import AracSection from "../../mainSections/AracSection";
import MenuSection from "../../mainSections/MenuSection";
import { useState } from "react";
import RoutePlanlamaSection from "../../mainSections/RoutePlanlamaSection";
import YuklemeSection from "../../mainSections/YuklemeSection";
import BosaltmaSection from "../../mainSections/BosaltmaSection";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getClearPermisionLoadDataPiece,
  setRequiredPlacesErrors,
  setSelectedProjectAddLoad,
  updateErrorDataList,
} from "../../../../features/addLoad/addLoadSlice";
import {
  showModal,
} from "../../../../features/modal/modalSlice";
import { useEffect } from "react";
import Btn from "../../../shared/button/Btn";
import { getAracTypes } from "../../../../features/adminSett/adminSettSlice";
import useWindowDimensions from "../../../../hooks/useWindowSize";
import InputProjectName from "../../../shared/input/special/InputProjectName";

const Container = styled.div`
  width: calc(100% - 540px);

  .wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.mainTextColor};

    .top-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .title-container{
        display: flex;
        align-items: center;
        gap: 20px;
      }

      h3 {
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-xl);
      }

      .icon-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
        span{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          text-decoration: underline;
          color: var(--color-main);
          cursor: pointer;
        }
        .clear-data-piece-btn {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          text-decoration: underline;
        }

        .sett-icon {
          font-size: 2rem;
        }
      }
    }

    .group {
      margin: 20px 0;
      display: flex;
      flex-direction: column;
      gap: 20px;
      padding-left: 40px;
    }

    .menu-section-container {
      width: 100%;
      margin: 20px 60px;
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 1300px){
    .top-container{
      flex-direction: column;
      gap: 15px;
    }
  }
`;



const InputSide = ({yukKayit}) => {
  // const {phase} = useSelector(state => state.addLoad)
  const {isKayitLoad, kayitliProjectId} = useSelector((state) => state.kayit)
  const dispatch = useDispatch();
  const { companyProjectNames } = useSelector(state => state.isOrtaklari)

  const { route, yukData, aracData, paymentData, paketlemeData, showErrors, errorDataList, selectedProjectAddLoad } = useSelector((state) => state.addLoad);
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const {windowDimensions} = useWindowDimensions()
    const rld = JSON.parse(storage.getItem("rld"))
  const menuList = [
    {
      id: 1,
      name: "Yükleme",
      errorList: errorDataList.yuklemeDataErrorList
    },
    {
      id: 2,
      name: "Boşaltma",
      errorList: errorDataList.bosaltmaDataErrorList
    },
    {
      id: 3,
      name: "Rota Planlama",
      errorList: []
    },
    {
      id: 4,
      name: "Yük",
      errorList: errorDataList.yukDataErrorList
    },
    {
      id: 5,
      name: "Araç",
      errorList: errorDataList.aracDataErrorList
    },
    {
      id: 6,
      name: "Ödeme",
      errorList: errorDataList.paymentDataErrorList
    },
  ];


  const [phase, setPhase] = useState({
    id: 1,
    name: "Yükleme",
  });

  useEffect(() => {
    storage.setItem("routeData", JSON.stringify(route));
    storage.setItem("yukData", JSON.stringify(yukData));
    storage.setItem("aracData", JSON.stringify(aracData));
    storage.setItem("paymentData", JSON.stringify(paymentData));
    storage.setItem("paketlemeData", JSON.stringify(paketlemeData));
  }, [route, yukData, aracData, paymentData, paketlemeData]);

  useEffect(() => {
    if(showErrors){
      let yukDataErrorList = [];
      let paymentDataErrorList = [];
      let aracDataErrorList = [];

      let yuklemeDataErrorList = [];
      let bosaltmaDataErrorList = [];

        yukData.yuklemeTuru.value === "" && yukDataErrorList.push("Yükleme Türünü");
        (yukData?.agirlikBirim?.value !== 3 && yukData.toplamAgirlik === "") && yukDataErrorList.push("Toplam Ağırlığı");

        aracData.aracTypeName === "" && aracDataErrorList.push("Araç Türünü");
        aracData.kasaTypeName === "" && aracDataErrorList.push("Kasa Türünü");

        paymentData.fiyatlandirmaType.value === "" && paymentDataErrorList.push("Fiyatlandırma Tipini");

        const yuklemeList = route.filter(item => item.locationType === "yukleme") 
        const bosaltmaList = route.filter(item => item.locationType === "bosaltma") 

        yuklemeList.forEach(item => {
          !item.date && yuklemeDataErrorList.push("Yükleme Tarihini")
          !item.locationData.location && yuklemeDataErrorList.push("İl ve İlçe yi")
          // !item.adres && yuklemeDataErrorList.push("Adres Bilgisini")
        });

        bosaltmaList.forEach(item => {
          // !item.date && bosaltmaDataErrorList.push("Boşaltma Tarihini")
          !item.locationData.location && bosaltmaDataErrorList.push("İl ve İlçe yi")
          // !item.adres && bosaltmaDataErrorList.push("Adres Bilgisini")
        });


        dispatch(updateErrorDataList({yukDataErrorList, paymentDataErrorList, aracDataErrorList, yuklemeDataErrorList, bosaltmaDataErrorList}))
    }
  },[route, yukData, aracData, paymentData, paketlemeData, showErrors])

  useEffect(() => {
    if(kayitliProjectId){
      const project = companyProjectNames.find(item => item.id === kayitliProjectId)
      dispatch(setSelectedProjectAddLoad(project))
    }
  }, [kayitliProjectId])
  
  useEffect(() => {
    dispatch(getAracTypes())
},[])

  return (
    <Container>
      <div className="wrapper">
        <div className="top-container">
          <div className="title-container">
            <h3>Bir Taşıma Talebi Oluştur</h3>
            {
              !yukKayit &&
              <>
                <Btn width={"140px"} borderColor={"transparent"} bgColor="#E85446" handleClick={()=> dispatch(showModal("addTopluYuk"))}>
                  Toplu Yük Girin
                </Btn>
                <Btn width={"140px"} borderColor={"transparent"} bgColor="#E85446" handleClick={()=> dispatch(showModal("fastLoad"))}>
                  Hızlı Yük Girin
                </Btn>
              </>
            }
          </div>

          <div className="icon-wrapper">
            {phase.id !== 3 && (
              <button
                className="clear-data-piece-btn"
                onClick={() => {
                  dispatch(getClearPermisionLoadDataPiece(phase));
                  dispatch(showModal("clearPermisionLoadDataPiece"));
                }}
              > 
                {phase.name} Aşaması Verilerini Temizle
              </button>
            )}
            {/* <IoSettingsSharp
              onClick={() => dispatch(setRequiredPlacesErrors(true))}
            /> */}
            <span onClick={() => dispatch(setRequiredPlacesErrors(true))}>Zorunlu Alanları Göster</span>
          </div>
        </div>

{
  !yukKayit &&
        <div className="group">
          <KayitliYuklerimInput />
          <InputProjectName data={selectedProjectAddLoad?.projectName || ""} initialOptions={companyProjectNames} inputWidth={"500px"}  name={"projectName"} labelText={"Proje(Zorunlu)"} isRequired={true} />
        </div>
}
        
        {windowDimensions?.width > 1200 &&
          <div className="menu-section-container">
            <MenuSection phase={phase} setPhase={setPhase} menuList={menuList}/>
          </div>
        }
                


        <div className="section-container">
          {phase.id === 1 && (
            <YuklemeSection
              isKayitLoad={isKayitLoad}
              setPhase={setPhase}
              yuklemeDataList={route?.filter(
                (item) => item?.locationType === "yukleme"
              )}
            />
          )}

          {phase.id === 2 && (
            <BosaltmaSection
              isKayitLoad={isKayitLoad}
              setPhase={setPhase}
              bosaltmaDataList={route?.filter(
                (item) => item?.locationType === "bosaltma"
              )}
            />
          )}

          {phase.id === 3 && <RoutePlanlamaSection setPhase={setPhase} yukKayit={yukKayit} />}

          {phase.id === 4 && <LoadSection setPhase={setPhase} yukKayit={yukKayit} />}

          {phase.id === 5 && <AracSection setPhase={setPhase} yukKayit={yukKayit} />}

          {phase.id === 6 && <OdemeSection setPhase={setPhase} yukKayit={yukKayit} />}
        </div>
      </div>
    </Container>
  );
};

export default InputSide;
